/* @jsxImportSource react */

import type { ReactNode } from 'react';

import { PriceOldPrice } from '../PriceOldPrice/PriceOldPrice';

export interface PriceVoucherDiscountProps {
  children: ReactNode;
  // TODO: the naming should probably be consistent with PriceDiscount
  preVoucherPrice: string;
  /** read by screen readers before the pre-voucher price, which is otherwise a bare amount */
  preVoucherPriceAriaLabel?: string;
  savingValue: string;
  /* 
    Defines if the old price can have a strikethrough style, for legal reasons this may not always be allowed.

    As this also can vary between different regions/tenants, the styling itself is handled in the theme CSS.
   */
  allowStrikethrough?: boolean;
}

const PriceVoucherDiscount = ({
  children,
  savingValue,
  preVoucherPrice,
  preVoucherPriceAriaLabel,
  allowStrikethrough,
}: PriceVoucherDiscountProps) => (
  <div className="grid grid-cols-1 [justify-items:inherit] [grid-area:b]">
    {preVoucherPriceAriaLabel && <span className="sr-only">{preVoucherPriceAriaLabel}</span>}
    <PriceOldPrice allowStrikethrough={allowStrikethrough}>{preVoucherPrice}</PriceOldPrice>
    <span className="price-voucher-discount text-size-body-xs inline-flex h-2 grow-0 items-center justify-start empty:hidden">
      <span className="bg-color-grey-light mr-0.5 inline-flex h-2 items-center justify-start rounded-sm px-1">
        {children}
      </span>
      <span className="inline-flex">{savingValue}</span>
    </span>
  </div>
);

PriceVoucherDiscount.displayName = 'PriceVoucherDiscount';

export { PriceVoucherDiscount };
